var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-section certs"},[_c('h2',[_vm._v("Certifications")]),_c('div',{staticClass:"main-content"},[_c('ul',{staticClass:"certifications"},_vm._l((this.certifications),function(ref,key){
var name = ref.name;
var imgSrc = ref.imgSrc;
var url = ref.url;
return _c('li',{key:key},[_c('a',{staticClass:"certification",attrs:{"href":url}},[_c('img',{attrs:{"src":imgSrc}}),_c('span',{staticClass:"pre-formatted"},[_vm._v(_vm._s(name))])])])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }